import React from 'react';
import { translate } from "sulu-admin-bundle/utils/Translator";
import style from '../scss/style.scss';

export default class TranslatableMultipleStringTransformer {
    transform(value, options) {
        if (!value) {
            return null;
        }

        const separator = options.separator || ',';
        const translatedValue = value.filter(item => item).map(item => translate(`${options.baseKey}.${item}`)).join(`${separator} `);

        return <span className={style.textBox} title={translatedValue}>{translatedValue}</span>;
    }
}
